/**
 * DB collection-card hover variant picker (ADR-0004).
 *
 * Desktop pointer devices only. On case-2 cards (data-db-picker="true"), clicking a
 * swatch or size opens the quick-add drawer preselected to a complete variant:
 *   - swatch -> the swatch's data-variant-id (first available variant of that color)
 *   - size   -> the current color + the clicked size, resolved from the slim variant JSON
 *
 * Clicks are intercepted in the capture phase and stopImmediatePropagation() neutralises
 * the vendor ProductCard handlers (swatch -> navigate, size -> direct add). The vendor
 * swatch mouseover image-swap is left intact, so hovering a color still previews it.
 *
 * On touch / no-hover devices this script does nothing; the card's anchors take the
 * shopper straight to the PDP (the picker markup is hidden by db-card-variant-picker.css).
 */
(function () {
  'use strict';

  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    return;
  }

  function parseVariants(card) {
    var json = card.querySelector('.db-card-picker [type="application/json"]');
    if (!json) {
      return null;
    }
    try {
      return JSON.parse(json.textContent);
    } catch (e) {
      return null;
    }
  }

  function openDrawer(card, variantId) {
    var trigger = card.querySelector('.db-card-picker--trigger');
    if (!trigger) {
      return;
    }
    if (variantId) {
      trigger.dataset.variantId = variantId;
    } else {
      delete trigger.dataset.variantId;
    }
    trigger.click();
  }

  // Resolve the current color + clicked size to a variant id from the slim variant JSON.
  function resolveSizeVariant(card, sizeValue) {
    var variants = parseVariants(card);
    if (!variants) {
      return null;
    }

    var sizeContainer = card.querySelector('.product-card-sizes');
    var swatchContainer = card.querySelector('.product-card-swatches');
    var sizeIndex = sizeContainer ? parseInt(sizeContainer.dataset.index, 10) : 0;
    if (isNaN(sizeIndex)) {
      sizeIndex = 0;
    }

    var current = (sizeContainer && sizeContainer.dataset.options) ? sizeContainer.dataset.options.split(',') : [];

    if (swatchContainer) {
      var colorIndex = parseInt(swatchContainer.dataset.index, 10);
      var active = swatchContainer.querySelector('.product-card-swatch.active') || swatchContainer.querySelector('.product-card-swatch');
      if (active && !isNaN(colorIndex)) {
        var span = active.querySelector('span');
        if (span) {
          current[colorIndex] = span.textContent.trim();
        }
      }
    }

    current[sizeIndex] = sizeValue;

    var match = variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return current[i] === undefined || current[i] === opt;
      });
    });

    if (!match) {
      match = variants.find(function (v) { return v.options[sizeIndex] === sizeValue && v.available; })
        || variants.find(function (v) { return v.options[sizeIndex] === sizeValue; });
    }

    return match ? match.id : null;
  }

  // All wiring is document-level delegation in the capture phase: facets.js replaces
  // #ProductGridContainer innerHTML on every filter/sort, which would orphan any
  // per-element listener (SlideCart's app-wide interception previously masked this
  // for the direct-add forms). Capture-phase + stopImmediatePropagation still
  // neutralises the vendor ProductCard element handlers (swatch -> navigate,
  // size -> direct add), since capture visits document before the element.
  function onPickerActivate(e) {
    if (!e.target || !e.target.closest) {
      return;
    }
    var el = e.target.closest('.db-card-picker .product-card-swatch, .db-card-picker .product-card-sizes--size');
    if (!el) {
      return;
    }
    var card = el.closest('product-card[data-db-picker="true"]');
    if (!card) {
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    if (el.classList.contains('product-card-swatch')) {
      openDrawer(card, el.dataset.variantId);
      return;
    }
    if (el.classList.contains('is-disabled')) {
      return;
    }
    var span = el.querySelector('span');
    var sizeValue = el.dataset.dbOptionValue || (span ? span.textContent.trim() : '');
    openDrawer(card, resolveSizeVariant(card, sizeValue));
  }

  document.addEventListener('click', onPickerActivate, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      onPickerActivate(e);
    }
  }, true);

  // Case 1: the direct-add form is a real /cart/add form for no-JS resilience, but
  // with JS we route the submit through the vendor ProductCard.addToCart ajax path,
  // which re-renders the cart sections and opens the native cart drawer in place
  // (ADR-0006; SlideCart previously intercepted the plain form submit). Case 2/3
  // quick-view adds need no code here: vendor product.js closes the quick-view and
  // opens the cart drawer itself when the submitted form lives inside the quick-view.
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('.db-card-direct-add-form') : null;
    if (!form) {
      return;
    }
    var card = form.closest('product-card');
    var button = form.querySelector('button[type="submit"]');
    var idInput = form.querySelector('[name="id"]');
    if (!card || typeof card.addToCart !== 'function' || !button || !idInput) {
      return; // let the plain form POST land on /cart
    }
    if (!window.theme || !window.theme.routes || !window.theme.routes.cart_add_url) {
      return; // theme global broken on this page (see the collection_id DB-EDIT in theme.liquid); plain POST still adds
    }
    e.preventDefault();
    if (button.disabled || button.classList.contains('loading')) {
      return;
    }
    card.addToCart(idInput.value, button);
  }, true);
})();
